import { isToday } from 'date-fns';
import { toZonedTime, format as tzFormat } from 'date-fns-tz';

const formatSchedule = (schedule) => {
  // Define the Toronto time zone
  const timeZone = 'America/Toronto';

  // Parse the start time to a Date object in UTC and then convert to Toronto time
  const startTime = toZonedTime(schedule.start, timeZone);

  // Check if the start time is today, using the same timezone
  const dayLabel = isToday(startTime)
    ? 'Today'
    : tzFormat(startTime, 'EEEE', { timeZone });

  // Use the provided schedule start and end times (assuming they are strings)
  return `${dayLabel}: ${schedule.start_time.toUpperCase()} - ${schedule.end_time.toUpperCase()}`;
};

export default formatSchedule;
